import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-top":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Add User ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Owner")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_checkbox = _resolveComponent("el-checkbox")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogUser = true))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.listUser,
      stripe: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "email",
          label: "Email"
        }),
        _createVNode(_component_el_table_column, {
          prop: "owner",
          label: ""
        }, {
          default: _withCtx((scope) => [
            (scope.row.owner)
              ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Inspect",
          width: "200px"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (_ctx.clickSetup(scope.row)),
              icon: "el-icon-edit"
            }, null, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              icon: "el-icon-delete",
              onClick: ($event: any) => (_ctx.handleDelete(scope.row._id))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      title: "Add User",
      modelValue: _ctx.dialogUser,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogUser = $event)),
      width: "700px"
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSave()))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogUser = false))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "form",
          model: _ctx.formValidateUser
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: "Email",
              rules: [
          {
            required: true,
            message: 'Please input email address',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change'],
          },
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formValidateUser.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formValidateUser.email = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  "show-password": "",
                  modelValue: _ctx.formValidateUser.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formValidateUser.password = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Confirm" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  "show-password": "",
                  modelValue: _ctx.formValidateUser.passwordConfirm,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formValidateUser.passwordConfirm = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Skip Two-Factor Authentication" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  "active-color": "#13ce66",
                  modelValue: _ctx.formValidateUser.skip_2fa,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formValidateUser.skip_2fa = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Update User",
      modelValue: _ctx.dialogUserDetail,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogUserDetail = $event)),
      width: "700px"
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleUpdate()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleClose()))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "form",
          model: _ctx.formValidateUser
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Change Password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  onChange: _ctx.changePassWord,
                  modelValue: _ctx.isChanged,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isChanged = $event))
                }, null, 8, ["onChange", "modelValue"])
              ]),
              _: 1
            }),
            (_ctx.isChanged)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_el_form_item, { label: "New Password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        "show-password": "",
                        modelValue: _ctx.formValidateUser.password,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formValidateUser.password = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "Confirm New Password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        "show-password": "",
                        modelValue: _ctx.formValidateUser.passwordConfirm,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formValidateUser.passwordConfirm = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "Skip Two-Factor Authentication" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  "active-color": "#13ce66",
                  modelValue: _ctx.formValidateUser.skip_2fa,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formValidateUser.skip_2fa = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Status" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  "active-color": "#13ce66",
                  modelValue: _ctx.formValidateUser.status,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formValidateUser.status = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}